import React, {useEffect, useState} from 'react';
import _ from "lodash";
import {useHistory,Link} from "react-router-dom";
import {useKeycloak} from "@react-keycloak/web";
import plusCircle from '../../assets/images/plus-circle.svg';
import Blocks from "../blocks";
import studyLogin from "../../assets/images/study-login.svg";
import {getVirtualClasses} from "../../utils/reactQueries";
import { FiEdit } from 'react-icons/fi';

const PageTeacherHome = () => {
    const history = useHistory();
    const {keycloak, initialized} = useKeycloak();
    const [classes, setClasses] = useState([]);
    const [classCreatedUrl, setClassCreatedUrl] = useState("");
    const {status, data: classData, error, isFetching} = getVirtualClasses();

    useEffect(() => {
        const classList = classData?.data?.body;
        if (classList?.length > 0) {
            setClasses(classList);
        }
    }, [classData]);

    const liveClassPage = () => {
        history.push('/teacher/start-live-class');
    }
    const newClassPage = () => {
        history.push('/create-virtual-class');
    }

    const countClass = (classes) => {
        const classCount = classes?.filter((item)=>item.student_count > 0);
        return classCount?.length;
    }
     if (status === 'loading') {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>Error loading classes</div>;
    }
    return (
        <>
            <div className="page pageTeacherHome relative min-h-screen"> {/* Added relative and min-h-screen */}
                <div className="container mx-auto pb-16"> {/* Added pb-16 for bottom padding */}
                    <div className="flex flex-col md:flex-row items-center">
                        <div className="left-section bgWrapper">
                            <img src={studyLogin} alt="" draggable={false}/>
                        </div>
                        <div className="right-section flex items-center justify-center w-full max-w-2xl ml-auto ">
                            <Blocks.ErrorBoundary>
                                <div className="w-full p-4">
                                    <div
                                        className="w-full text-1xl break-all text-center md:text-left md:text-4xl font-['Poppins-Bold'] mx-auto mb-2 block">
                                        Hi {_.capitalize(keycloak?.tokenParsed?.given_name)},
                                    </div>
                                    <div className="text-center md:text-left font-['Poppins'] mx-auto block">
                                        welcome
                                    </div>
                                    <div
                                        className="w-full flex flex-wrap  justify-center md:justify-start gap-2 md:gap-6 my-4 md:my-10">
                                        <button
                                            onClick={() => newClassPage()}
                                            className={"h-52 w-44  text-white ease-in-out duration-300 focus:scale-101 hover:scale-101 focus:ring-2 focus:ring-offset-2 hover:ring-2 hover:ring-offset-2 shadow rounded-lg  p-3 mb-6 text-lg"}>
                                            <div className="inline-block h-fit w-fit mx-auto mt-[25px]">
                                                <img src={plusCircle} className="h-14 w-14" draggable={false}/>
                                            </div>
                                            <div className="text-sm mt-[40px] text-black">create a new class</div>
                                        </button>
                                        {
                                            classes?.length > 0 && (
                                                <span>
                                                <button
                                                    onClick={() => liveClassPage()}
                                                    className={"h-52 w-44  bg-white ease-in-out duration-300 focus:scale-101 hover:scale-101 focus:ring-2 focus:ring-offset-2 hover:ring-2 hover:ring-offset-2 shadow rounded-lg  p-3 text-lg"}>
                                                    <div className="mt-[30px]">
                                                        <i className="icon icon-arrow-right text-6xl mr-3 mt-[25px]"></i></div>
                                                    <div className="text-sm mt-2">start a live class</div>
                                                   <div className="text-sm ml-auto text-green-400 ">
                                                     {`${countClass(classes)} Upcoming Class${countClass(classes) === 1 ? '' : 'es'}`}
                                                     </div>
                                                </button>
                                            </span>
                                            )
                                        }
                                    </div>
                                </div>
                            </Blocks.ErrorBoundary>
                        </div>
                    </div>
                </div>
                {classCreatedUrl !== "class" && (
                    <div className="fixed bottom-4 right-4 z-10"> 
                        <Link
                            to={`/teacher/${keycloak?.idTokenParsed?.sid}/edit-teacher-profile`}
                            
                        >
                        <span className="ml-2 border-b border-b-black">Edit profile</span>
                        </Link>
                    </div>
                )}
            </div>
        </>
    )
};

export default PageTeacherHome;